export interface BridgeErrorProps {
  title?: string
  subtitle?: string
  publisher?: string
}

export class BridgeError extends Error {
  public title?: string
  public subtitle?: string
  public publisher?: string

  constructor(errors?: BridgeErrorProps) {
    super(errors?.title)
    this.name = 'BridgeError'
    this.title = errors?.title
    this.subtitle = errors?.subtitle
    this.publisher = errors?.publisher
  }
}
